import { render } from "./SpecifyInvoiceDialog.vue?vue&type=template&id=5a60f25c&ts=true"
import script from "./SpecifyInvoiceDialog.vue?vue&type=script&lang=ts"
export * from "./SpecifyInvoiceDialog.vue?vue&type=script&lang=ts"

import "./SpecifyInvoiceDialog.vue?vue&type=style&index=0&id=5a60f25c&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__